import React, { useState } from "react";
import CloudDownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import Papa from "papaparse";
import CustomAddModal from "./CustomAddModal";

const CsvDownloader = ({ data, target = "page" }) => {
  const [open, setOpen] = useState(false);
  const downloadCSV = () => {
    try {
      const csv = Papa.unparse(data);

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `DemoCsv${Date.now()}.csv`);
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading CSV:", error.message);
      alert("Failed to download CSV.");
    }
  };

  return (
<>
      <button
        onClick={() => setOpen(true)}
        className="h-[24px] px-2.5 bg-white hover:bg-gray-50 border border-slate-300 text-slate-700 text-[11px] font-medium rounded-none flex items-center justify-center gap-1.5 cursor-pointer whitespace-nowrap"
      >
        <CloudDownloadIcon style={{ fontSize: 14 }} className="text-slate-600" />
        <span>Download Demo CSV</span>
      </button>
      <CustomAddModal
        open={open}
        handleClose={() => setOpen(false)}
        onClose={() => setOpen(false)}
        title="Demo CSV"
        saveLabel="Download"
        onSubmitConfirm={() => { downloadCSV(); setOpen(false); }}
      >
        <div className="text-[12px] text-slate-700">
          <div className="border border-slate-200 bg-slate-50 px-3 py-3">
            <div className="font-semibold text-slate-900 mb-1">What is this file?</div>
            <p>A sample Address Book CSV with the exact column headings and one example contact. It is for the contact type selected next to this button (Individual or Organisation).</p>
          </div>
          <div className="font-semibold text-slate-900 mt-4 mb-2">How to use it</div>
          <ol className="list-decimal pl-5 space-y-2">
            <li>Select <strong>Individual</strong> or <strong>Organisation</strong>, then click <strong>Download</strong> below to save the sample CSV.</li>
            <li>Open it in Excel or any spreadsheet app. Keep the header row unchanged and replace the example row with your own contact details.</li>
            <li>Save the file as <strong>.csv</strong>.</li>
          </ol>
          <div className="font-semibold text-slate-900 mt-4 mb-2">Where can I upload it?</div>
          {target === "form" ? (
            <ol className="list-decimal pl-5 space-y-2">
              <li>In this contact form, click <strong>Upload CSV</strong> (next to Download Demo CSV).</li>
              <li>Select your saved CSV. The first row of the file is used to fill in the form fields below, and you can edit them before saving.</li>
            </ol>
          ) : (
            <ol className="list-decimal pl-5 space-y-2">
              <li>On the Address Book page, make sure the same <strong>Individual</strong> or <strong>Organisation</strong> type is selected, then click <strong>Upload CSV</strong>.</li>
              <li>Drag and drop your CSV (or click to select it). Up to 3000 rows are allowed, and rows with an invalid email address are skipped.</li>
              <li>Click <strong>Upload File</strong> to add the contacts to your Address Book.</li>
            </ol>
          )}
        </div>
      </CustomAddModal>
    </>
  );
};

export default CsvDownloader;
